var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emergency-webview"},[_c('span',{staticClass:"emergency-tabs__head"},[_vm._v("Webview")]),_c('a-input',{staticClass:"webview-input mt-2",attrs:{"placeholder":"https://"},on:{"change":_vm.changeWebviewValue},model:{value:(_vm.webviewValue),callback:function ($$v) {_vm.webviewValue=$$v},expression:"webviewValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }